/*******************************************************************************
* Licensed Materials - Property of HCL
* (c) Copyright HCL Technologies Ltd. 2020, 2023. All Rights Reserved.

* Note to U.S. Government Users Restricted Rights:
* Use, duplication or disclosure restricted by GSA ADP Schedule
**************************************************************/

import React from "react";
import { useSelector } from "react-redux";
import { Carousel, Text } from "vr-react-components";
import { getFormattedTime } from "../utils/TimeUtils";

const DisplayingPlansWidget = React.memo(
    ({ width, height, textSizeDecimal, arrows, ...otherAttributes }) => {
        const canModify = useSelector((state) => state.private.device.canModify);
        const currentPlanDates = useSelector((state) => state.homeroom.currentPlanDates);

        const generatePages = () => {
            return currentPlanDates.map((plan) => {
                const textSize = textSizeDecimal * 1.15;
                const localHeight = arrows === "bottom" ? height * 0.8 : height;
                const localWidth = arrows === "bottom" ? width : width * 0.7;
                return (
                    <a-entity>
                        <a-entity position={`${-localWidth * 0.4} 0 0`}>
                            <Text
                                width={localWidth}
                                sizeDecimal={textSize}
                                text={plan.engine}
                                align="left"
                                position={`0 ${localHeight * 0.05} 0`}
                                baseline="bottom"
                            />
                            <Text
                                width={localWidth * 0.25}
                                sizeDecimal={textSize}
                                text="Start:"
                                align="left"
                                position={`0 ${-localHeight * 0.15} 0`}
                                baseline="bottom"
                            />
                            <Text
                                width={localWidth * 0.2}
                                sizeDecimal={textSize}
                                text="End:"
                                align="left"
                                position={`0 ${-localHeight * 0.35} 0`}
                                baseline="bottom"
                            />
                        </a-entity>
                        <a-entity position={`${localWidth * 0.4} 0 0`}>
                            <Text
                                width={localWidth * 0.5}
                                sizeDecimal={textSize}
                                text={getFormattedTime(plan.start) || "Not available"}
                                align="right"
                                position={`0 ${-localHeight * 0.15} 0`}
                                baseline="bottom"
                            />
                            <Text
                                width={localWidth * 0.5}
                                sizeDecimal={textSize}
                                text={getFormattedTime(plan.end) || "Not available"}
                                align="right"
                                position={`0 ${-localHeight * 0.35} 0`}
                                baseline="bottom"
                            />
                        </a-entity>

                        <a-entity
                            line={`start:${-localWidth * 0.45} ${localHeight * 0.04
                                } 0;end:${localWidth * 0.45} ${localHeight * 0.04
                                } 0;color:#c6c6c6;opacity:0.5`}
                        />

                        <a-entity
                            line={`start:${-localWidth * 0.45} ${-localHeight * 0.16
                                } 0;end:${localWidth * 0.45} ${-localHeight * 0.16
                                } 0;color:#c6c6c6;opacity:0.5`}
                        />

                        <a-entity
                            line={`start:${-localWidth * 0.45} ${-localHeight * 0.36
                                } 0;end:${localWidth * 0.45} ${-localHeight * 0.36
                                } 0;color:#c6c6c6;opacity:0.5`}
                        />
                    </a-entity>
                );
            });
        };

        return (
            <Carousel
                width={width}
                height={height}
                pages={currentPlanDates ? generatePages() : []}
                aframeClasses={canModify ? "collidable" : ""}
                title="Displaying Plan (by engine selected)"
                textSizeDecimal={textSizeDecimal}
                arrows={arrows}
                {...otherAttributes}
            />
        );
    },
);

export default DisplayingPlansWidget;
